/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import CompareAction from './CompareAction/index'
import ImageSeriesSelector from './ImageSeriesSelector/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Actions"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ImageSeriesSelector
  viewPath={`${viewPath}/ImageSeriesSelector`}
/>
<CompareAction
  viewPath={`${viewPath}/CompareAction`}
/>
</div>
{children}
</React.Fragment>)
}